export default function Footer() {
   return (
      <footer>
         <p className="credits">
            Coded by{" "}
            <a
               href="https://github.com/di-legorreta"
               target="_blank"
               rel="noopener noreferrer"
            >
               Diana Legorreta
            </a>{" "}
            open-sourced on{" "}
            <a
               href="https://github.com/di-legorreta/react-final-project"
               target="_blank"
               rel="noopener noreferrer"
            >
               GitHub
            </a>{" "}
            and hosted on{" "}
            <a
               href="https://react-final-project-6wj.pages.dev/"
               target="_blank"
               rel="noopener noreferrer"
            >
               Cloudflare Pages
            </a>
         </p>
      </footer>
   );
}
